"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnified = exports.isEvent = void 0;

// Too much files to change
var isUnified = function isUnified(topic) {
  return 'publicId' in topic;
};

exports.isUnified = isUnified;

var isEvent = function isEvent(topic) {
  return topic.contentType === 'event';
};

exports.isEvent = isEvent;